export enum ExportTypeEnum {
  MemberExport = 'memberExport',
  MemberSnapshot = 'memberSnapshot',
  MemberList = 'memberList',
  BookKeepingRecordExport = 'bookKeepingRecordExport',
  AddressLabelExport = 'addressLabelExport',
  AutogiroMandate = 'autogiroMandate',
  depositExport = 'depositExport',
}
